module.exports = __webpack_public_path__ + "img/media-29.ac8947d4.png";